'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BackButton = require('components/BackButton/BackButton');

var _BackButton2 = _interopRequireDefault(_BackButton);

var _PlaylistHomeButton = require('../PlaylistHomeButton/PlaylistHomeButton');

var _PlaylistHomeButton2 = _interopRequireDefault(_PlaylistHomeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlaylistNavButtons = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistNavButtons, _PureComponent);

  function PlaylistNavButtons() {
    (0, _classCallCheck3.default)(this, PlaylistNavButtons);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistNavButtons.__proto__ || (0, _getPrototypeOf2.default)(PlaylistNavButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistNavButtons, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          playlistKey = _props.playlistKey,
          contentType = _props.contentType,
          user = _props.user;

      var isPlayByKey = playlistKey && !user;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('margin-bottom-20', className) },
        user && _react2.default.createElement(_BackButton2.default, { backUrl: '/playlists/' + contentType }),
        _react2.default.createElement(_PlaylistHomeButton2.default, { hidden: !isPlayByKey })
      );
    }
  }]);
  return PlaylistNavButtons;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  contentType: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  user: _propTypes2.default.object
}, _temp);
exports.default = PlaylistNavButtons;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlist/components/PlaylistNavButtons/PlaylistNavButtons.js
// module id = 2180
// module chunks = 1